define('../src/sublayouts/m23-price-table/m23-price-table',['jquery', 'lib/utils', 'mask', 'spinner'], function ($, utils, Mask, Spinner) {
    'use strict';

    var M19_TABLE = function ($component) {

        this.$component = $component;

        return this;
    };

    M19_TABLE.prototype.init = function () {
        var _this = this,
            tableHeader = _this.$component.find('.m23-price-table__content-table-header'),
            headToTop = tableHeader.offset().top;

        $(window).scroll(function () {
            _this.fix(tableHeader, headToTop)
        })
        $(window).on('orientationchange resize', function () {
            if (tableHeader.hasClass('fixed')) {
                _this.setWidth(tableHeader)
            }
        });
        if (tableHeader.hasClass('fixed')) {
            _this.setWidth(tableHeader)
        }
    };

    M19_TABLE.prototype.fix = function ($element, toTop) {
        var _this = this,
            isPositionFixed = ($element.css('position') == 'fixed'),
            winScroll = $(window).scrollTop() + 91;

        if (winScroll > toTop) {
            $element.ea
            $element.css({ 'position': 'fixed', 'top': '91px' });
            $element.addClass('fixed')
        } else {
            $element.css({ 'position': 'static', 'top': '0px' });
            $element.removeClass('fixed')
        }
        _this.setWidth($element)
    };

    M19_TABLE.prototype.setWidth = function (tHeader) {
        var _this = this,
            tableWidth = tHeader.closest('.m23-price-table__content-table').width();
            tHeader.css('width',tableWidth)
    };

    return M19_TABLE;

});

